import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  intiatePayment,
  processTrans,
  checkAMstatus,
  getOtpV1,
  getLineType,
} from "../../../shared/service";
import { useLoading } from "../../../../../Shared/cache/context/LoadingProvider";
import ToastMsg from "../../../shared/components/ToastMsg/ToastMsg";
import { eventEmitter } from "../../../../../Shared/service/google-analytics.service";
import useFetch from "../../../../../Shared/cache/useFetch";
import { TRANSLATION,GET, ORP_TRANSLATION } from "../../../../../Shared/helper/constants";
import { useLanguage } from "../../../../../Shared/cache/context/LanguageProvider";
import AwOtpModal from "../../../../odu/components/AwOtpModal";
import AirtelMoneyPinComponent from "../AirtelMoneyPinComponent";
import { INTIATE_PAYMENT, INTIATE_PAYMENT_AM_PIN, PROCESS_TRXN, PROCESS_TRXN_AM_PIN } from "../../../helper/constants";
import { AW_TRANSANCTION_TYPE } from "../../../../odu/constant/constant";

const AirteMoneyPayment = () => {
  const [formData, setFormData] = useState({amPhoneNo: "" });
  const [txnInfo, setTxnInfo] = useState();
  const [email, setEmailId] = useState();
  const [emailError, setEmailError] = useState("");
  const [msisdnError, setMsisdnError] = useState("");
  const { showLoader, hideLoader } = useLoading();
  const [toastMsg ,setToastMsg]=useState(null);
  const [translation, setTranslation] = useState({
    howWillYouPay: "How will you pay",
    cancel: "Cancel",
    continueToPay: "Continue to pay",
    am_push_message_note: "Note : Your transaction is in progress. Please do not press back button",
    push_messages_start: "Hi, We have sent authentication request on this number.",
    push_messages_end: "Please enter your Airtel Money Pin on your mobile to proceed with the transaction.",
    processing:"Processing"
  })
  const navigate = useNavigate();
  const { languagePrefix ,selectedLanguage} = useLanguage();
  const [leadInfo,setLeadInfo]=useState({})
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [refId,setRefId]=useState('');
  const [showAmPinModal,setShowAmPinModal]=useState(false);
  const [config,setConfig]=useState({});
  const [showIncorrectPinMessage,setShowIncorrectPinMessage]=useState(false);
  const [showPinLockedMessage,setShowPinLockedMessage]=useState(false);
  const [noOfAttemptsLeftForPIN, setNoOfAttemptsLeftForPIN] = useState(5);
  const [token,setToken]=useState('');
  const [isAirtelNumber,setIsAirtelNumber]=useState(false);
  const [showLoadingMsg, setShowLoadingMsg] = useState(false)
  
  const { data: data ,refetch} = useFetch({
    url: ORP_TRANSLATION.replace('languagePrefix',languagePrefix),
    method: GET,
    key: TRANSLATION,
    initialEnabled: false,
    cache: {
      enabled: true,
      ttl: 3600
    }
  });

  useEffect(() => {
    const cachedData = sessionStorage.getItem(`${TRANSLATION}_${selectedLanguage}`);
    if (!cachedData) {
        refetch(true);
    }else {
      refetch(false)
    }
}, [selectedLanguage]);


useEffect(() => {
  let txnInfo = sessionStorage.getItem("queryData");
  txnInfo = JSON.parse(txnInfo);
  setTxnInfo({ ...txnInfo });
  let leadInformation = sessionStorage.getItem('airtelWorks');
   if(leadInformation){
    leadInformation= JSON.parse(leadInformation||{})
    setLeadInfo(leadInformation);
  }
  let configData= sessionStorage.getItem( "_c_o_n_f_i_g");
  setConfig(JSON.parse(configData));
  setEmailId(txnInfo?.emailId);
  setFormData({
    ...formData, amPhoneNo:process.env?.REACT_APP_X_COUNTRY?.toLowerCase() == "ga"? txnInfo?.msisdn.substring(1) : txnInfo?.msisdn,
    email: txnInfo?.emailId || "",
  });
}, []);

useEffect(() => {
        if(data?.payment.amPayment) 
          {
            setTranslation(data?.payment.amPayment)
          }
}, [data])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: e.target.value });
    if (name == "email") {
      if (value.trim() === "") {
        setEmailError("Email is required");
        return;
      }

      if (!e.target.checkValidity()) {
        setEmailError("Invalid Email Id");
      } else {
        setEmailError("");
      }
    }

    if (name == "amPhoneNo") {
      if (value.trim() === "") {
        setMsisdnError("Phone No is required");
      } else {
        setMsisdnError(""); // Clear error if input is valid
      }
    }
  };

  const checkMsisdn=(val,event)=>{
    if (val) {
      val = val.replace(/[^0-9]/g, "");
      formData.amPhoneNo = val;
      if(event){
        event.target.value = val;
      }
      if (val?.length == process.env.REACT_APP_NUMBER_MAX_LENGTH) {
        //once backend is ready
        validateMsisdn();
      }
    }
 }
 const validateMsisdn=()=>{
     let requestData = {
       msisdn: process.env.REACT_APP_OPCO.toLowerCase() == "ga" ? "0" + formData.amPhoneNo :formData.amPhoneNo,
       checkIfBroadband:  false,
       requestType: ''
     };
        showLoader();
        getLineType(requestData).then(
        (res) => {
         res = res?.data;
         hideLoader();
         if(res?.status?.toLowerCase()=="success" || res?.status?.toLowerCase()==200 ){
            setIsAirtelNumber(true);
         }else{
          setMsisdnError("Please enter valid Airtel number");
         }
       })
     .catch((error)=>{
       hideLoader();
       showToastMsg('Error',error?.error?.message ||error?.message|| "Something Went Wrong!")
     })
   
   }

 

  const showToastMsg= (type,message)=>{
    setToastMsg({type,message});
    setTimeout(()=>setToastMsg(null),10000);
  }

  const initiateRecharge = (event=undefined,pin) => {
    if(event){
      event?.preventDefault();
    }
    if(showPinLockedMessage){
      return
    }
    showLoader();
    let postRequestData = {
      paymentMobile:
        process.env.REACT_APP_OPCO.toLowerCase() == "ga"
          ? "0" + formData.amPhoneNo
          : formData.amPhoneNo,
      amount: txnInfo.amount, //Esb api object
      countryCode: process.env.REACT_APP_COUNTRY_CODE || "234",
      currencyCode: process.env.REACT_APP_CURRENCY,
      emailId: email || "",
      mobileNumber: txnInfo?.msisdn,
      productCode: txnInfo?.productCode || null,
      transactionType: leadInfo?.isAirtelWorks ? AW_TRANSANCTION_TYPE: txnInfo?.transactionType,
      unit: Number(txnInfo?.amount),
      loggedInNumber:
        (txnInfo?.invoiceDetail && txnInfo?.invoiceDetail?.accountNo) || null,
      accountId:
        (txnInfo?.invoiceDetail && txnInfo?.invoiceDetail?.accountNo) || null,
      invoiceNumber:
        (txnInfo?.invoiceDetail && txnInfo?.invoiceDetail?.invoiceNo) || null,
      paymentMode: config?.enableAmPin ? "AIRTEL_MONEY":"AIRTEL_MONEY_PUSH",
      txnId: leadInfo.id || ""
    };
    
   
  const headers = {};
  if (config?.enableAmPin) {
    headers['Authorization'] = `${token?.tokenType} ${token?.accessToken}`
  }
    let postRequest = {
      data: postRequestData,
      url: config?.enableAmPin ? INTIATE_PAYMENT_AM_PIN : INTIATE_PAYMENT,
      headers:headers
    };
    intiatePayment(postRequest)
      .then((res) => {
        res = res?.data;
        // hideLoader();
        if (
          res &&
          (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
        ) {
          res?.result?.transactionId
            ? processRecharge(res?.result?.transactionId,pin)
            : console.error("error txn id not found", res);
            eventEmitter('ORP','Initiate AirtelMoney Payment Success','click','Initiate AirtelMoney Payment Success',null);
        } else {
          hideLoader();
          console.log("error");
          showToastMsg('Error',res?.message || "Something Went Wrong!")
          eventEmitter('ORP','Initiate AirtelMoney Payment Failed','click',res?.statusCode?.toString()  || res?.message,null);
          // testing purpose , remove later 
          // setShowAmPinModal(false);
          // setShowOtpModal(false);
          // setShowIncorrectPinMessage(true);
        }
      })
      .catch((error) => {
        hideLoader();
        console.log(error);
        showToastMsg('Error',error?.error?.message ||error?.message|| "Something Went Wrong!")
      });
  };

  const processRecharge = (txnId,pin ) => {
    let postRequestData = {
      paymentMobile:
        process.env.REACT_APP_OPCO.toLowerCase() == "ga"
          ? "0" + formData.amPhoneNo
          : formData.amPhoneNo,
      transactionId: txnId,
      isSubscriberRequest: true,
      paymentMode:config?.enableAmPin ? "AIRTEL_MONEY":"AIRTEL_MONEY_PUSH",
      proccessFlag: true,

    };
    const headers={};
    if (config?.enableAmPin) {
      headers['Authorization'] = `${token?.tokenType} ${token?.accessToken}`
    }
    let postRequest = {
      data: {...postRequestData,...(config?.enableAmPin ?{amPin:pin}:{})},
      url: config?.enableAmPin ? PROCESS_TRXN_AM_PIN : PROCESS_TRXN,
      headers
    };
    // showLoader();
    processTrans(postRequest)
      .then((res) => {
        res = res?.data;
        // hideLoader();
        if (
          res &&
          (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
        ) {
          if(!config?.enableAmPin){
             hideLoader()
             setShowLoadingMsg(true)
          }
          let transactionId = res?.result?.transactionId;
          transactionId
            ? callCheckStatus(transactionId)
            : console.log("Transaction ID not found in the api response", res);
          eventEmitter('ORP', 'Process AirtelMoney Payment Success', 'click', 'Process AirtelMoney Payment Success', null);
        } else if (res?.statusCode == 1004) {
          hideLoader();
          setShowIncorrectPinMessage(true);
          if (noOfAttemptsLeftForPIN > 0) {
            setNoOfAttemptsLeftForPIN((prev) => prev - 1)
          }
        }
        else if (res?.statusCode === 1006) {
          hideLoader();
          setShowPinLockedMessage(true);
          setShowIncorrectPinMessage(false);
          setNoOfAttemptsLeftForPIN(0)
        }
         else {
          hideLoader();
          showToastMsg('Error', res?.message || "Something Went Wrong!")
          eventEmitter('ORP', 'Process AirtelMoney Payment Failed', 'click', res?.statusCode?.toString() || res?.message, null);
          setShowAmPinModal(false);
          setShowOtpModal(false);
        }
      })
      .catch((error) => {
        hideLoader();
        setShowLoadingMsg(false);
        showToastMsg('Error',error?.error?.message ||error?.message|| "Something Went Wrong!")
        eventEmitter('ORP','Process AirtelMoney Payment Failed','click',error?.error?.toString(),null);
      });
  };

  const callCheckStatus = (txnId) => {
    // showLoader();
    checkAMstatus(txnId).then(
      (res) => {
        res = res?.data;
        if (
          res &&
          (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
        ) {
          if (res?.result && res?.result?.transactionStatus) {
            if (
              res?.result?.transactionStatus &&
              res?.result?.transactionStatus == "IN_PROCESS"
            ) {
              let intervalId = setTimeout(() => callCheckStatus(txnId), 10000);
              return;
            } else {
              if (res?.result?.transactionId) {
                // hideLoader();
                setShowLoadingMsg(false);
                navigateToStatusPage(res?.result?.transactionId);
              }
            }
            eventEmitter('ORP','AirtelMoney Payment Check Status Success','click','AirtelMoney Payment Check Status Success',null);
          } else {
          }
        } else {
          setShowAmPinModal(false)
          setShowOtpModal(false);
         showToastMsg('Error',res?.message|| "Something Went Wrong!")
         eventEmitter('ORP','AirtelMoney Payment Check Status Failed','click',res?.message,null);

        }
      },
      (error) => {
        // hideLoader();
        setShowAmPinModal(false)
        setShowOtpModal(false);
        showToastMsg('Error',error?.error?.message ||error?.message|| "Something Went Wrong!")
        eventEmitter('ORP','AirtelMoney Payment Check Status Failed','click',error?.error?.toString(),null);

      }
    );
  };

  const navigateToStatusPage = (txnId) => {
    if (txnId) {
      navigate("/payment/status?id=" + txnId);
      return;
    }
  };

  const cancelTransaction = () => {
    navigate(txnInfo.redirectPage);
  };

  // const checkMsisdn = (val, event) => {
  //   if (val) {
  //     val = val.replace(/[^0-9]/g, "");
  //     formData.amPhoneNo = val;
  //     event.target.value = val;
  //   }
  // };

  const sendOtp = (event) => {
    event.preventDefault()
      let postRequestData = {
        msisdn: process.env.REACT_APP_OPCO.toLowerCase() == "ga"
        ? "0" + formData.amPhoneNo
        : formData.amPhoneNo,
        // email:'maninderjit.kaur@africa.airtel.com'
      };
      let postRequest = {
        data: postRequestData,
      };
      showLoader();
      getOtpV1(postRequest).then(
        (res) => {
          res = res?.data;
          hideLoader();
          if (
            res &&
            (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
          ) {
            setShowOtpModal(true);
            setRefId(res?.result?.refId);
          } else {
            if (res &&
              (res?.status == 502 || res?.statusCode == 502)) {
              handleLimitExhaust();
            }
            setShowOtpModal(false);
            showToastMsg("Error", res?.message || "Something Went Wrong!");
          }
        },
        (error) => {
          hideLoader();
          setShowOtpModal(false);
          showToastMsg(
            "Error",
            error?.error?.message || error?.message || "Something Went Wrong!"
          );
        }
      );
    };

  const handleLimitExhaust = (message) => {
  setShowOtpModal(false);
  showToastMsg("Error", message || "max limit exhausted, please try after sometime.");
  }

  const handleInvalidAmUser = (message) => {
    setMsisdnError(message);
  }

  const handleOtpVerified =(token)=>{
    setToken(token)
    setShowAmPinModal(true);
    setShowIncorrectPinMessage(false)
    setShowPinLockedMessage(false)
  }

  const handleEncrypedPin=(pin)=>{
    initiateRecharge('',pin);
  }

  const handleOtpModalClose =()=>{
    setShowOtpModal(false);
  }
  const handlePinModalClose =()=>{
    setShowOtpModal(false);
    setShowAmPinModal(false)
  }

  return (
    <>
      <div className="card-pay-container">
        <h3>{translation?.howWillYouPay}</h3>
        <form autoComplete="off">
          <div className="card-pay-footer airtime_payment_form">
            {/* <div className="card-pay-form">
              <img src="assets/icons/email.svg" />
              <input
                type="text"
                name="email"
                placeholder="Email id"
                value={formData.email}
                required
                pattern="^[a-zA-Z0-9]+[a-zA-Z0-9._]+@[a-zA-Z0-9]+\.[a-zA-Z.]{2,}$"
                className="entermobileno"
                onChange={handleChange}
              />
              {emailError && <p className="error">{emailError}</p>}
            </div> */}
            <div className="card-pay-form">
              <span className="country_code">
                +{process.env.REACT_APP_COUNTRY_CODE}
              </span>
              <input
                type="text"
                name="amPhoneNo"
                placeholder="Enter Phone No"
                value={formData.amPhoneNo}
                onChange={handleChange}
                onInput={(event) => checkMsisdn(event.target.value, event)}
                maxLength={process.env.REACT_APP_NUMBER_MAX_LENGTH}
                readOnly={showLoadingMsg}
              />
              {msisdnError && <p className="error">{msisdnError}</p>}
            </div>
          </div>
          <div className="card-pay-payment-button">
            <button onClick={cancelTransaction} className="cancel-btn">
              {translation?.cancel}
            </button>
            <button
              className="continue-btn"
              disabled={msisdnError || showLoadingMsg}
              onClick={(event) => config?.enableAmPin ? sendOtp(event) : initiateRecharge(event)}
            >
              {translation?.continueToPay}
            </button>
          </div>
        </form>
      </div>
      {toastMsg && <ToastMsg message={toastMsg.message} type={toastMsg.type} onClose={()=> setToastMsg(null)}></ToastMsg>}
      {showOtpModal && <AwOtpModal
      toggleModalEvent={handleOtpModalClose}
        enableAmPin={config?.enableAmPin }
        inValidAmUserEvent={handleInvalidAmUser}
        refId={refId}
        msisdn={formData.amPhoneNo}
        sendOtpVerifiedEvent={handleOtpVerified}
        maxLimitExaustEvent={handleLimitExhaust}
        isAirtelNumber={isAirtelNumber ? isAirtelNumber : true }
      />}
      {showAmPinModal && <AirtelMoneyPinComponent
        amount={txnInfo?.amount}
        sendEncryptedPin={handleEncrypedPin}
        showIncorrectPinMessage={showIncorrectPinMessage}
        showPinLockedMessage={showPinLockedMessage}
        noOfAttemptsLeftForPIN={noOfAttemptsLeftForPIN}
        customerCareNumber={config?.customerCareNumber}
        dial={config?.pinResetDial}
        toggleModalEvent={handlePinModalClose}
      />}
          {showLoadingMsg && <div className="am-loader-container">
                <div class="processing">
                    {translation.processing}
                    <div class="dots">
                        <div class="dot"></div>
                        <div class="dot"></div>
                        <div class="dot"></div>
                    </div>
                </div>
                <p> {translation.push_messages_start} ({formData.amPhoneNo}). {translation.push_messages_end}
                    <span>
                        {translation.am_push_message_note}
                    </span></p >
            </div >
          }
      
    </>
  );
};
export default AirteMoneyPayment;
